import api from '../config/api';
import {
  FETCH_UNTRACED_USERS_LOADING,
  FETCH_UNTRACED_USERS_SUCCESS,
  FETCH_UNTRACED_USERS_FAILURE
} from '../Types/untracedUsersTypes';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchUntracedUsersSuccess = (data) => {
  return {
    type: FETCH_UNTRACED_USERS_SUCCESS,
    payload: data
  };
};

export const fetchUntracedUsersError = (error) => {
  return {
    type: FETCH_UNTRACED_USERS_FAILURE,
    payload: error
  };
};

export const fetchUntracedUsers = (start, end) => {
  return dispatch => {
    dispatch({
      type: FETCH_UNTRACED_USERS_LOADING
    });
    
    api
      .get(`${API_URL}Operation/getUsersWithNoTrace/${start}/${end}`)
      .then(response => {
        const requests = response.data.data;
        dispatch(fetchUntracedUsersSuccess(requests));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchUntracedUsersError(errorMsg));
      });
  };
}; 